export interface SimNaoModel {
    valor: boolean;
    descricao: string;
}

export const SimNaoList: SimNaoModel[] = [
    { valor: true, descricao: "Sim" },
    { valor: false, descricao: "Não" },
]